"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Container } from "@mui/material";
import SubfamilyComparisonChart from "../../Charts/CompareToTaxapad2016/SubfamilyComparisonChart";

export default function ComparisonWithChecklists() {
  const { t } = useTranslation(["analysis", "common"]);

  const titleSx = {
    fontWeight: 800,
    letterSpacing: "0.01em",
    color: "text.primary",
    textAlign: "center",
    mb: 1,
  };

  const subtitleSx = {
    textAlign: "center",
    whiteSpace: "pre-line",
    color: "text.secondary",
    maxWidth: 820,
    mx: "auto",
    mb: 4,
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h2" sx={titleSx}>
        {t("analysis:comparison.title")}
      </Typography>
      <Typography variant="body1" sx={subtitleSx}>
        {t("analysis:comparison.description")}
      </Typography>
      <Box pt={4} id="comparison-with-checklists">
        <SubfamilyComparisonChart initialFamily="all" />
      </Box>
    </Container>
  );
}
